import React, {useEffect, useRef} from "react";
import "./style.scss";
import {observer} from "mobx-react";
import {useTranslation} from "react-i18next";
import _ from "lodash";
import {Block, Col, Row, Typography, Progress} from "@bezlimit/bezlimit-ui";
import cn from "classnames";
//store
import Store from "../../../../stores";
//services
import LoyaltyService from "../../../../services/LoyaltyService";

export const Loyalty: React.FC = observer(() => {
    const {t} = useTranslation();
    const mountedRef = useRef(true);

    const getUserInfo = async () => {
        if (!mountedRef.current) {
            return;
        }
        await LoyaltyService.getLoyalty();
    };

    useEffect(() => {
        getUserInfo();
        return () => {
            mountedRef.current = false;
        };
    }, []);

    const getProgressPersent = (
        code: string,
        upgrade_cnt: number,
        last_month_cnt: number
    ): number => {
        if (code === "top" || _.gte(last_month_cnt, 50)) {
            return 100;
        }
        if (!upgrade_cnt) {
            return 0;
        }
        return (100 * last_month_cnt) / (last_month_cnt + upgrade_cnt);
    };

    return (
        <Block className="bl-widget-loyalty">
            <Row gutter={[32, 16]}>
                <Col span={24}>
                    <div className="title-row">
                        {_.isNil(Store.user.loyalty) ? (
                            <>
                                <Typography className="loyalty-code">Персональный</Typography>
                            </>
                        ) : (
                            <>
                                <Typography
                                    className={cn(
                                        "loyalty-code",
                                        `${Store.user.loyalty?.code ?? ""}`
                                    )}
                                >
                                    {Store.user.loyalty?.name}
                                </Typography>
                                <Typography className="subtitle">
                                    {t("Программа лояльности")}
                                </Typography>
                            </>
                        )}
                    </div>
                </Col>
                <Col span={24}>
                    {!_.isNil(Store.user.loyalty) && (
                        <>
                            {Store.user.loyalty?.code !== "top" ? (
                                <div className="loyalty-status">
                                    <Typography className="subtitle">
                                        {t("До следующего статуса")}
                                    </Typography>
                                    <Typography className="loyalty-status-count">
                                        {Store.user.loyalty?.upgrade_cnt ?? 0}
                                    </Typography>
                                </div>
                            ) : (
                                <Typography className="subtitle">
                                    {t("Вы достигли максимального уровня")}
                                </Typography>
                            )}
                        </>
                    )}

                    <Progress
                        className="loaylty-progress-line"
                        percent={getProgressPersent(
                            Store.user.loyalty?.code,
                            Store.user.loyalty?.upgrade_cnt,
                            Store.user.level?.activation?.last_month_cnt
                        )}
                        showInfo={false}
                    />
                </Col>
                <Col span={24}>
                    <div className="activation">
                        <div className="activation-row">
                            <Typography>{t("Активаций за последние 30 дней")}</Typography>
                            <Typography className="activation-cnt gold">
                                {Store.user.level?.activation?.last_month_cnt ?? 0}
                            </Typography>
                        </div>
                        {Store.user.level?.level < 2 && (
                            <div className="activation-row">
                                <div className="activation-col">
                                    <Typography>{t("Дилерские")}</Typography>
                                    <Typography className="activation-cnt gold">
                                        {Store.user.level?.activation?.last_month_level_cnt ?? 0}
                                    </Typography>
                                </div>
                                <div className="activation-col">
                                    <Typography>{t("Личные")}</Typography>
                                    <Typography className="activation-cnt gold">
                                        {Store.user.level?.activation?.last_month_personal_cnt ?? 0}
                                    </Typography>
                                </div>
                            </div>
                        )}
                    </div>
                </Col>
            </Row>
        </Block>
    );
});
